export default "__VITE_ASSET__BQh$fWLY__"